import je from "../InAppMessage/in-app-message-manager-factory.js";
import r, { OPTIONS as D } from "../managers/braze-instance.js";
import gr from "./triggers-provider.js";
export const TriggersProviderFactory = {
  i: !1,
  provider: null,
  o: () => (
    TriggersProviderFactory.t(),
    TriggersProviderFactory.provider || TriggersProviderFactory.rg(),
    TriggersProviderFactory.provider
  ),
  rg: () => {
    if (!TriggersProviderFactory.provider) {
      const i = r.re(D.Xh);
      (TriggersProviderFactory.provider = new gr(
        null != i ? i : 30,
        je.ra().An(),
        r.p(),
        r.nn(),
        je.ra(),
      )),
        r.v(TriggersProviderFactory.provider);
    }
  },
  t: () => {
    TriggersProviderFactory.i ||
      (TriggersProviderFactory.rg(),
      r.g(TriggersProviderFactory),
      (TriggersProviderFactory.i = !0));
  },
  destroy: () => {
    (TriggersProviderFactory.provider = null), (TriggersProviderFactory.i = !1);
  },
};
